import React from 'react';
import PropTypes from 'prop-types';


const IconDrag = ({ width = '16px', height = '17px' }) => {
    return <svg width={width} height={height} viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M10 4.5C9.44772 4.5 9 4.05228 9 3.5C9 2.94772 9.44772 2.5 10 2.5C10.5523 2.5 11 2.94772 11 3.5C11 4.05228 10.5523 4.5 10 4.5Z' fill='#1F1F1F' />
        <path d='M6 4.5C5.44772 4.5 5 4.05228 5 3.5C5 2.94771 5.44772 2.5 6 2.5C6.55228 2.5 7 2.94772 7 3.5C7 4.05228 6.55228 4.5 6 4.5Z' fill='#1F1F1F' />
        <path d='M10 9.5C9.44771 9.5 9 9.05228 9 8.5C9 7.94772 9.44772 7.5 10 7.5C10.5523 7.5 11 7.94772 11 8.5C11 9.05228 10.5523 9.5 10 9.5Z' fill='#1F1F1F' />
        <path d='M6 9.5C5.44771 9.5 5 9.05228 5 8.5C5 7.94772 5.44772 7.5 6 7.5C6.55228 7.5 7 7.94772 7 8.5C7 9.05228 6.55228 9.5 6 9.5Z' fill='#1F1F1F' />
        <path d='M10 14.5C9.44771 14.5 9 14.0523 9 13.5C9 12.9477 9.44771 12.5 10 12.5C10.5523 12.5 11 12.9477 11 13.5C11 14.0523 10.5523 14.5 10 14.5Z' fill='#1F1F1F' />
        <path d='M6 14.5C5.44771 14.5 5 14.0523 5 13.5C5 12.9477 5.44771 12.5 6 12.5C6.55228 12.5 7 12.9477 7 13.5C7 14.0523 6.55228 14.5 6 14.5Z' fill='#1F1F1F' />
    </svg>;

};

IconDrag.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconDrag;
